import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const hasSendingEmailReceiptSucceeded = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.sendEmailReceipt.hasSucceeded);
